export const userRole = {
    DOCTOR: 'fea360ae-9278-4c0c-a83c-122c3ffb6cbc',
    NURSE: 'ad212364-4f91-4355-a169-9ecdc032f261',
    PHARMACIST: '85a438c4-22a3-4019-a066-081d4b7f26a6',
    INTERPRETER: 'fe8bceaf-cbbf-4685-b533-69329ae09784',
    PATIENT: 'ffb48f9b-a9b9-49e6-b575-239ee34de169',
};

export const EXPRESSIONS_COLORS = Object.freeze({
    angry: '#FD322C',
    disgusted: '#8943BF',
    fearful: '#FF8C2F',
    happy: '#70D56E',
    neutral: '#6A6A6A',
    sad: '#2675B8',
    surprised: '#FED12E',
});

export const SESSION_COLORS = Object.freeze({
    group: 'purple',
    one: 'pink',
    open: 'green',
});

export const SESSION_TYPE = Object.freeze({
    group: 'Group session',
    one: '1 on 1 session',
    open: 'OPEN session',
});
export const SMALL_SESSION_TYPE = Object.freeze({
    group: 'Group',
    one: '1 on 1',
    open: 'OPEN',
});

export const CALENDAR_STATE = Object.freeze({
    SESSIONS: 'SESSIONS',
    SELECT_BULK: 'SELECT_BULK',
    SELECT_ONE: 'SELECT_ONE',
});

export const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

/* ---------- style ---------- */
export const providerPageWidth = '1200px';
export const patientPageWidth = '800px';

/* ---------- Open Rules & Conditions ---------- */
export const OPEN_RULES_TH = [
    {
        id: 'openRulesTH01',
        text: 'คุณตกลงว่าคุณจะไม่พยายามแทรกแซงการทำงานของ open session นี้และคุณจะไม่ดำเนินการใดๆ ที่ก่อให้เกิดการประมวลผลจำนวนมากที่ไม่สมเหตุสมผลใน open session นี้',
    },
    {
        id: 'openRulesTH02',
        text: 'คุณตกลงว่าคุณจะไม่คัดลอก ทำซ้ำ เปลี่ยนแปลงหรือแก้ไขเนื้อหาใด ๆ จาก open session นี้โดยไม่ได้รับอนุญาต',
    },
    {
        id: 'openRulesTH03',
        text: 'คุณรับทราบว่าบริการที่เกิดขึ้นใน open session นี้เกิดขึ้นโดยผู้นำเสนอ และ FRIDAY นั้นไม่มีส่วนรับผิดชอบต่อความถูกต้องหรือความสมบูรณ์ของการให้บริการดังกล่าว',
    },
    {
        id: 'openRulesTH04',
        text: 'คุณรับทราบว่าความคิดเห็นต่างๆที่เกิดขึ้นใน open session นี้เป็นความคิดเห็นของผู้นำเสนอและสมาชิกเท่านั้น ไม่ได้มีเกี่ยวข้องกับความคิดเห็นของเจ้าหน้าที่ และ/หรือตัวแทนของ FRIDAY',
    },
    {
        id: 'openRulesTH05',
        text: 'คุณรับทราบว่าคุณสามารถออกจาก open session นี้ได้ตลอดเวลาโดยไม่มีผลกระทบใดๆต่อคุณ',
    },
];

export const OPEN_RULES_EN = [
    {
        id: 'openRulesEN01',
        text: 'You agree that you will neither attempt to interfere with the proper working of this open session nor take any action that imposes an unreasonable large load on this open session.',
    },
    {
        id: 'openRulesEN02',
        text: 'You agree that you will not copy, reproduce, alter, or modify any content from this open session without given permission.',
    },
    {
        id: 'openRulesEN03',
        text: 'You acknowledge that materials or links presented in this open session are provided by contributors, and FRIDAY will not assume any responsibility or liability for the accuracy or completeness of content contained in the materials or links.',
    },
    {
        id: 'openRulesEN04',
        text: 'You acknowledge that the opinions expressed in this open session are solely the opinions of the contributors and members and do not represent the opinions of FRIDAY, its officers and/or its representatives.',
    },
    {
        id: 'openRulesEN05',
        text: 'You acknowledge that you can withdraw from this open session at any time without any consequence.',
    },
];

/* ---------- Group Rules & Conditions ---------- */
export const GROUP_RULES_TH = [
    {
        id: 'groupRulesTH01',
        text: 'คุณตกลงว่าคุณจะไม่พยายามแทรกแซงการทำงานของ group session นี้และคุณจะไม่ดำเนินการใดๆ ที่ก่อให้เกิดการประมวลผลจำนวนมากที่ไม่สมเหตุสมผลใน group session นี้',
    },
    {
        id: 'groupRulesTH02',
        text: 'คุณตกลงว่าคุณจะไม่คัดลอก ทำซ้ำ เปลี่ยนแปลงหรือแก้ไขเนื้อหาใด ๆ จาก group session นี้โดยไม่ได้รับอนุญาต',
    },
    {
        id: 'groupRulesTH03',
        text: 'คุณรับทราบว่าเนื้อหาทุกอย่างที่ถูกพูดถึงในกลุ่มนี้จะต้องถูกเก็บรักษาเป็นความลับ คุณยินยอมที่จะปกปิดรายชื่อของสมาชิกในกลุ่มและสิ่งที่ได้พูดถึงไว้เป็นความลับ และคุณยินยอมที่จะปกปิดรายละเอียดทุกอย่างที่เกิดขึ้นทั้งในและระหว่างกลุ่มเป็นความลับเสมอ',
    },
    {
        id: 'groupRulesTH04',
        text: 'คุณรับทราบว่ามีข้อยกเว้นสำหรับการรักษาความลับของผู้นำกลุ่ม หากผู้นำกลุ่มคิดว่ามีสมาชิกตกอยู่ในอันตราย ผู้นำกลุ่มจะสามารถดำเนินการตามหน้าที่ทางวิชาชีพได้โดยตรงเพื่อให้ทุกคนปลอดภัย',
    },
    {
        id: 'groupRulesTH05',
        text: 'คุณรับทราบว่าจะไม่มีสมาชิกคนใดในกลุ่มถูกบังคับให้ตอบคำถาม หากคุณถูกถามหรือให้เข้าร่วมกิจกรรมหรือเปิดเผยข้อมูลใด ๆ ที่คุณไม่สบายใจ คุณมีสิทธิที่จะขอข้าม ปฏิเสธการตอบคำถาม และไม่เข้าร่วมกิจกรรมนั้น ๆ',
    },
    {
        id: 'groupRulesTH06',
        text: 'คุณรับทราบว่าสมาชิกในกลุ่มจะต้องไม่ถูกทำให้อับอาย ดูหมิ่น และเหยียดหยาม ไม่ว่าทางใดทางหนึ่ง และคุณตกลงที่จะหลีกเลี่ยงพฤติกรรมที่ก่อให้เกิดความเสียหาย',
    },
    {
        id: 'groupRulesTH07',
        text: 'คุณรับทราบว่าบริการที่เกิดขึ้นใน group session นี้เกิดขึ้นโดยผู้นำกลุ่ม และ FRIDAY นั้นไม่มีส่วนรับผิดชอบต่อความถูกต้องหรือความสมบูรณ์ของการให้บริการดังกล่าว',
    },
    {
        id: 'groupRulesTH08',
        text: 'คุณรับทราบว่าความคิดเห็นต่างๆที่เกิดขึ้นใน group session นี้เป็นความคิดเห็นของผู้นำกลุ่มและสมาชิกเท่านั้น ไม่ได้มีเกี่ยวข้องกับความคิดเห็นของเจ้าหน้าที่ และ/หรือตัวแทนของ FRIDAY',
    },
];

export const GROUP_RULES_EN = [
    {
        id: 'groupRulesEN01',
        text: 'You agree that you will neither attempt to interfere with the proper working of this group session nor take any action that imposes an unreasonable large load on this group session.',
    },
    {
        id: 'groupRulesEN02',
        text: 'You agree that you will not copy, reproduce, alter, or modify any content from this group session without given permission.',
    },
    {
        id: 'groupRulesEN03',
        text: 'You acknowledge that every matter mentioned in this group will be confidential. You agree to keep secret the names of other members of the group and what will be discussed in the group. You also commit to always keeping confidential all interactions between group members.',
    },
    {
        id: 'groupRulesEN04',
        text: 'You acknowledge that there is an exception to this confidentiality which applies to the contributor. If the contributor believes that someone is in danger, the group leader has a professional obligation to take direct action in order to keep everyone safe.',
    },
    {
        id: 'groupRulesEN05',
        text: 'You acknowledge that group members will never be required to answer any question, to participate in any activity, or to reveal anything. If you are asked questions or asked to participate in an activity which makes you feel uncomfortable, you understand that you have the right to pass and the right to refuse.',
    },
    {
        id: 'groupRulesEN06',
        text: 'You acknowledge that group members must not be humiliated, hazed, or abused in any way. You also agree to avoid any destructive behavior.',
    },
    {
        id: 'groupRulesEN07',
        text: 'You acknowledge that services presented in this group session are provided by the group leader, and FRIDAY will not assume any responsibility for the accuracy or completeness of content contained in this group session.',
    },
    {
        id: 'groupRulesEN08',
        text: 'You acknowledge that the opinions expressed in this group session are solely the opinions of the group leader and members and do not represent the opinions of FRIDAY, its officers and/or its representatives.',
    },
];

/* ---------- Activity ---------- */
const MoodTrackerIcon = '/resources/images/mindgym/01_mood_tracker.svg';
const BehavioralTrackerIcon = '/resources/images/mindgym/02_behavioral_tracker.svg';
const GratitudeJournalIcon = '/resources/images/mindgym/03_gratitude_journal.svg';
const CommunicationJournalIcon = '/resources/images/mindgym/04_communication_journal.svg';
const BreathingExerciseIcon = '/resources/images/mindgym/05_breathing_exercise.svg';
const ProgressiveMuscleRelaxationIcon =
    '/resources/images/mindgym/06_progressive_muscle_relaxation.svg';
const MindfulnessIcon = '/resources/images/mindgym/07_mindfulness.svg';
const AutomaticThoughtsinCBTIcon = '/resources/images/mindgym/08_automatic_thoughts_in_cbt.svg';
const CognitiveTriangleinCBTIcon = '/resources/images/mindgym/09_cognitive_triangle_in_cbt.svg';

const baseInputValue = Object.freeze({
    id: null,
    startDate: null,
    endDate: null,
    frequency: 1,
});

const getFrequenceOptions = (length) =>
    Array.from({ length: length }, (x, i) => ({
        value: i + 1,
        text: i + 1,
    }));

export const ACTIVITIES = Object.freeze({
    MOOD_TRACKER: {
        payloadType: 'moodTracker',
        title: 'Mood Tracker',
        icon: MoodTrackerIcon,
        description:
            'Mood Tracker workout is designed to help users monitor and understand their emotions, moods, and mental health.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'MOOD_TRACKER',
        },
        selectInput: [
            {
                label: 'Frequency (per day)',
                name: 'frequency',
                placeholder: 1,
                options: getFrequenceOptions(3),
            },
        ],
    },
    BEHAVIORAL_TRACKER: {
        payloadType: 'behavioralTracker',
        title: 'Behavioral Tracker',
        icon: BehavioralTrackerIcon,
        description:
            'Behavioral Tracker workout is designed to help users set, track, and maintain daily routines and behaviors to promote personal growth and mental well-being.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'BEHAVIORAL_TRACKER',
            workout: [],
        },
        workoutInput: true,
    },
    GRATITUDE_JOURNAL: {
        payloadType: 'gratitudeJournal',
        title: 'Gratitude Journal',
        icon: GratitudeJournalIcon,
        description:
            'Gratitude Journal is designed to help users cultivate gratitude by recording three positive experiences or "good things" daily.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'GRATITUDE_JOURNAL',
        },
    },
    COMMUNICATION_JOURNAL: {
        payloadType: 'communicationJournal',
        title: 'Communication Journal',
        icon: CommunicationJournalIcon,
        description:
            'Communication Journal is designed to help users track, reflect on, and improve their daily interactions and communication with others.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'COMMUNICATION_JOURNAL',
        },
        selectInput: [
            {
                label: 'Frequency (per day)',
                name: 'frequency',
                placeholder: 1,
                options: getFrequenceOptions(10),
            },
        ],
    },
    BREATHING_EXERCISE: {
        payloadType: 'breathingExercises',
        title: 'Breathing Exercise',
        icon: BreathingExerciseIcon,
        description:
            'Breathing Exercise workout is designed to guide users through a wide range of breathing techniques, customizable settings, progress tracking, and additional resources to support users’ practice journey.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'BREATHING_EXERCISE',
            workout: 'Coherent Breathing',
            duration: 5,
        },
        selectInput: [
            {
                label: 'Select workout feature',
                name: 'workout',
                placeholder: 'Box Breathing',
                options: [
                    { text: 'Coherent Breathing', value: 'Coherent Breathing' },
                    { text: '4-7-8 Breathing', value: '4-7-8 Breathing' },
                    { text: 'Box Breathing', value: 'Box Breathing' },
                    { text: 'Whiskey Breathing', value: 'Whiskey Breathing' },
                ],
            },
            {
                label: 'Select duration *',
                name: 'duration',
                placeholder: '5 mins (default)',
                options: [
                    { text: '1 mins', value: 1 },
                    { text: '3 mins', value: 3 },
                    { text: '5 mins (default)', value: 5 },
                    { text: '10 mins', value: 10 },
                    { text: '15 mins', value: 15 },
                    { text: '20 mins', value: 20 },
                ],
            },
            {
                label: 'Frequency (per day)',
                name: 'frequency',
                placeholder: 1,
                options: getFrequenceOptions(10),
            },
        ],
    },
    PROGRESSIVE_MUSCLE_RELAXATION: {
        payloadType: 'progressiveMuscleRelaxation',
        title: 'Progressive Muscle Relaxation',
        icon: ProgressiveMuscleRelaxationIcon,
        description:
            'Progressive Muscle Relaxation workout is designed to guide users through the process of progressive muscle relaxation, by systematically tensing and relaxing various muscle groups, with customizable settings, progress tracking, and additional resources to support users’ practice journey.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'PROGRESSIVE_MUSCLE_RELAXATION',
            duration: 20,
        },
        selectInput: [
            {
                label: 'Select duration *',
                name: 'duration',
                placeholder: '20 mins (default)',
                options: [
                    { text: '1 mins', value: 1 },
                    { text: '3 mins', value: 3 },
                    { text: '5 mins', value: 5 },
                    { text: '10 mins', value: 10 },
                    { text: '15 mins', value: 15 },
                    { text: '20 mins (default)', value: 20 },
                ],
            },
            {
                label: 'Frequency (per day)',
                name: 'frequency',
                placeholder: 1,
                options: getFrequenceOptions(10),
            },
        ],
    },
    MINDFULNESS: {
        payloadType: 'mindfulness',
        title: 'Mindfulness',
        icon: MindfulnessIcon,
        description:
            'Mindfulness workout is designed to guide users through the combination of mindfulness meditation and visualization techniques, with customizable settings, progress tracking, and additional resources to support users’ practice journey.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'MINDFULNESS',
            workout: 'Mindfulness by the River',
            duration: 20,
        },
        selectInput: [
            {
                label: 'Select workout feature',
                name: 'workout',
                placeholder: 'Mindfulness by the River',
                options: [
                    { text: 'Mindfulness by the River', value: 'Mindfulness by the River' },
                    { text: 'Mindfulness on the Beach', value: 'Mindfulness on the Beach' },
                    { text: 'Mindfulness in the Forest', value: 'Mindfulness in the Forest' },
                ],
            },
               {
                label: 'Select duration *',
                name: 'duration',
                placeholder: '20 mins (default)',
                options: [
                    { text: '1 mins', value: 1 },
                    { text: '3 mins', value: 3 },
                    { text: '5 mins', value: 5 },
                    { text: '10 mins', value: 10 },
                    { text: '15 mins', value: 15 },
                    { text: '20 mins (default)', value: 20 },
                ],
            },
            {
                label: 'Frequency (per day)',
                name: 'frequency',
                placeholder: 1,
                options: getFrequenceOptions(10),
            },
        ],
    },
    AUTOMATIC_THOUGHTS_IN_CBT: {
        payloadType: 'automaticThoughtsInCBT',
        title: 'Automatic Thoughts in CBT',
        icon: AutomaticThoughtsinCBTIcon,
        description:
            'Automatic Thought in CBT workout is a specialized tool designed to help users identify, analyze, and challenge their automatic thoughts, as part of Cognitive Behavioral Therapy (CBT). This advanced workout is intended to be used under the guidance of a mental health professional, such as a therapist, psychologist, or psychiatrist, to ensure proper implementation and support throughout the process.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'AUTOMATIC_THOUGHTS_IN_CBT',
        },
    },
    COGNITIVE_TRIANGLE_IN_CBT: {
        payloadType: 'cognitiveTriangleInCBT',
        title: 'Cognitive Triangle in CBT',
        icon: CognitiveTriangleinCBTIcon,
        description:
            'Cognitive Triangle in CBT workout is a specialized tool designed to help users understand and address the interrelationship between their thoughts, emotions, and behaviors, as part of Cognitive Behavioral Therapy (CBT). This advanced workout is intended to be used under the guidance of a mental health professional, such as a therapist, psychologist, or psychiatrist, to ensure proper implementation and support throughout the process.',
        defaultInputValue: {
            ...baseInputValue,
            type: 'COGNITIVE_TRIANGLE_IN_CBT',
        },
    },
});

export const DEFAULT_WORKOUT = [
    {
        type: 'FIT_AND_FIRM',
        title: 'Fit & firm',
        workout: [
            'Go to gym',
            'Aerobic exercise',
            'Walk',
            'Run',
            'Bike',
            'Weight training',
            'Yoga',
        ],
    },
    {
        type: 'HEALTHT_LIFESTYLE',
        title: 'Healthy lifestyle',
        workout: [
            'Less sweet food',
            'Less salty food',
            'Less fried food',
            'No soda',
            'No sweets and snacks',
            'No fast food',
            'More vegetable and fruits',
            'Drink more water',
            'Weigh yourself',
            'Control meal portion',
        ],
    },
    {
        type: 'BETTER_SLEEP',
        title: 'Better sleep',
        workout: [
            'No screens before sleep',
            'No late coffee',
            'Light dinner',
            'No naps',
            'Bedtime stretching',
            'Fixed bedtime',
        ],
    },
    {
        type: 'STRESS_RELIEVER',
        title: 'Stress reliever',
        workout: [
            'Outdoor time',
            'Breathing exercise',
            'Mindfulness meditation',
            'Progressive muscle relaxation',
            'Talking about your problems',
            'Rest',
            'Be grateful',
            'Connect to friends',
            'Write a brain dump',
        ],
    },
    {
        type: 'HABIT_TRANSFORMATION',
        title: 'Habit transformation',
        workout: [
            'No smoking',
            'No alcohol',
            'No drugs',
            'Reduce coffee',
            'Limit social media',
            'Limit TV',
            'Limit gaming',
            'No late nights',
            'No sleeping in',
        ],
    },
    {
        type: 'BLISSFUL_RELATIONSHIP',
        title: 'Blissful relationship',
        workout: [
            'Positive conversation',
            'More thanks and praise',
            'More smile',
            'Quality time',
            'Family mealtime',
            'Fun activities',
        ],
    },
];
